import React, { useEffect, useState } from "react";
import {
	Container,
	Typography,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	TextField,
	Button,
	MenuItem,
	Select,
	FormControl,
	InputLabel,
	Alert,
} from "@mui/material";
import { getCompanies, addCompany, getCompanyUsers, assignUserToCompany, getUsers } from "../services/api";
import { SubTitle, Title } from "./common/Title";
import { toggleCompanyStatus } from "../services/api";

const CompanyManagement = ({ token }) => {
	const [companies, setCompanies] = useState([]);
	const [newCompany, setNewCompany] = useState({ name: "", cnpj: "" });
	const [selectedCompany, setSelectedCompany] = useState("");
	const [companyUsers, setCompanyUsers] = useState([]);
	const [users, setUsers] = useState([]);
	const [selectedUser, setSelectedUser] = useState("");
	const [error, setError] = useState("");

	useEffect(() => {
		fetchCompanies();
		fetchUsers();
	}, []);

	const fetchCompanies = async () => {
		try {
			const data = await getCompanies(token);
			setCompanies(data);
		} catch {
			setError("Erro ao buscar empresas.");
		}
	};

	const fetchUsers = async () => {
		try {
			const data = await getUsers(token);
			setUsers(data);
		} catch {
			setError("Erro ao buscar usuários.");
		}
	};

	const fetchCompanyUsers = async (companyId) => {
		try {
			const data = await getCompanyUsers(token, companyId);
			setCompanyUsers(data);
		} catch {
			setError("Erro ao buscar usuários da empresa.");
		}
	};

	const handleToggleCompany = async (companyId) => {
		try {
			await toggleCompanyStatus(token, companyId);
			fetchCompanies();
		} catch {
			setError("Erro ao alterar status da empresa.");
		}
	};

	const handleAddCompany = async () => {
		if (!newCompany.name || !newCompany.cnpj) {
			setError("Nome e CNPJ são obrigatórios.");
			return;
		}
		try {
			await addCompany(token, newCompany);
			fetchCompanies();
			setNewCompany({ name: "", cnpj: "" });
		} catch {
			setError("Erro ao adicionar empresa.");
		}
	};

	const handleAssignUser = async () => {
		if (!selectedCompany || !selectedUser) {
			setError("Selecione uma empresa e um usuário.");
			return;
		}
		try {
			await assignUserToCompany(token, {
				companyId: selectedCompany,
				userId: selectedUser,
				role: "customer",
			});
			fetchCompanyUsers(selectedCompany);
		} catch {
			setError("Erro ao atribuir usuário à empresa.");
		}
	};

	return (
		<Container sx={{ mt: 4 }}>
			<Title>🏢 Gestão de Empresas</Title>
			{error && <Alert severity="error">{error}</Alert>}

			{/* Lista de Empresas */}
			<Paper elevation={3} sx={{ p: 3, mb: 3, borderRadius: 3 }}>
				<SubTitle>Lista de empresas</SubTitle>
				<TableContainer component={Paper} elevation={3}>
					<Table>
						<TableHead sx={{ backgroundColor: "#1976d2" }}>
							<TableRow>
								<TableCell sx={{ color: "white", fontWeight: "bold" }}>Nome</TableCell>
								<TableCell sx={{ color: "white", fontWeight: "bold" }}>CNPJ</TableCell>
								<TableCell sx={{ color: "white", fontWeight: "bold", textAlign: "center" }}>Status</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{companies.map((company) => (
								<TableRow sx={{ backgroundColor: company.is_enabled ? "" : "rgba(224, 32, 32, 0.1)" }} key={company.id}>
									<TableCell>{company.name}</TableCell>
									<TableCell>{company.cnpj}</TableCell>
									<TableCell align="center">
										<Button
											variant="contained"
											color={company.is_enabled ? "error" : "success"}
											onClick={() => handleToggleCompany(company.id)}
										>
											{company.is_enabled ? "Bloquear" : "Desbloquear"}
										</Button>
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>

				{/* Adicionar Nova Empresa */}
				<SubTitle variant="h6" sx={{ mt: 3 }}>
					Nova empresa
				</SubTitle>
				<TextField
					label="Nome da empresa"
					fullWidth
					margin="normal"
					value={newCompany.name}
					onChange={(e) => setNewCompany({ ...newCompany, name: e.target.value })}
				/>
				<TextField
					label="CNPJ"
					fullWidth
					margin="normal"
					value={newCompany.cnpj}
					onChange={(e) => setNewCompany({ ...newCompany, cnpj: e.target.value })}
				/>
				<Button variant="contained" color="primary" sx={{ mt: 2 }} onClick={handleAddCompany}>
					Adicionar empresa
				</Button>
			</Paper>
		</Container>
	);
};

export default CompanyManagement;
